import * as DIGITALSETS from './digitalSets.constants';
import { DigitalSet } from '../../models';

/** LOAD */
export function loadDigitalSets() {
    return { type: DIGITALSETS.DIGITAL_SETS_LOAD };
}

export function loadDigitalSetsSuccess(data: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_LOAD_SUCCESS, payload: data };
}

export function loadDigitalSetsError(error: any) {
    return { type: DIGITALSETS.DIGITAL_SETS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addDigitalSets(targetDigitalSets: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_ADD, payload: targetDigitalSets };
}

export function addDigitalSetsSuccess(targetDigitalSets: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_ADD_SUCCESS, payload: targetDigitalSets };
}

export function addDigitalSetsError(error: any) {
    return { type: DIGITALSETS.DIGITAL_SETS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateDigitalSets(targetDigitalSets: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_UPDATE, payload: targetDigitalSets };
}

export function updateDigitalSetsSuccess(targetDigitalSets: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_UPDATE_SUCCESS, payload: targetDigitalSets };
}

export function updateDigitalSetsError(error: any) {
    return { type: DIGITALSETS.DIGITAL_SETS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteDigitalSets(guids: string[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_DELETE, payload: guids };
}

export function deleteDigitalSetsSuccess(DigitalSets: DigitalSet[]) {
    return { type: DIGITALSETS.DIGITAL_SETS_DELETE_SUCCESS, payload: DigitalSets };
}

export function deleteDigitalSetsError(error: any) {
    return { type: DIGITALSETS.DIGITAL_SETS_DELETE_ERROR, payload: error };
}